import { Component, Input, OnInit } from '@angular/core';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';

import HexRgb from 'hex-rgb';

import { CtaSimple } from 'src/app/models/cta-simple';
import { UserVideo } from 'src/app/models/user-video';

@Component({
  selector: 'app-cta-simple-expand',
  templateUrl: './cta-simple-expand.component.html',
  styleUrls: ['./cta-simple-expand.component.scss']
})
export class CtaSimpleExpandComponent implements OnInit {

  @Input() userVideo:UserVideo;
  @Input() color:string;

  style:SafeHtml;

  constructor(
    private domSanitizer: DomSanitizer,
  ) { }

  ngOnInit() {
    let style:string = '';
    style += '@keyframes ctaExpandShowAnimation {';
    style +=   '0% {';
    style +=     'background-color: #fff;';
    style +=     'color: #000;';
    style +=   '}';
    style +=   '100% {';
    style +=     'background-color: ' + this.color + ';';
    style +=     'color: #fff;';
    style +=   '}';
    style += '}';    
    style = "<style>" + style + "</style>";
    this.style = this.domSanitizer.bypassSecurityTrustHtml(style);
  }

  ctaSimpleCtaClicked(){
    const content = this.userVideo.ctaSimple;

    console.log("CtaUpdate expand");

    // CTA送信
    if(window.onerollq){
      // Trackに送信
      let data = {
        userVideoHashPublic: null,
        hash: content.hash,
        title: content.title,
        url:content.linkUrl,
      };
      data.userVideoHashPublic = this.userVideo.hashPublic;
      window.onerollq('CtaUpdate', data);
    }
  }

}
